import React from "react";

import { useTranslation } from "react-i18next";

import type { IPartner } from "App/Modules/Models";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHandshakeAlt } from "@fortawesome/pro-light-svg-icons";
import { faUsers } from "@fortawesome/pro-solid-svg-icons";

type InjectedProps = {
    partner: IPartner;
};

type SupportingPartnersListProps = InjectedProps;

export const SupportingPartnersList = (props: SupportingPartnersListProps) => {
    const { t } = useTranslation();
    const { partner } = props;

    return partner.supportingPartners?.length > 0 ? (
        <div>
            <ul className="entity-list">
                {partner.supportingPartners.map((sp) => (
                    <li className="entity-list__item entity-list__item--stuffing" key={sp.id}>
                        <div className="entity-list__item-panel">
                            <div className="entity-list__item-value">
                                <div className="state-tag state-tag--light">
                                    <FontAwesomeIcon className="state-tag__icon" icon={faHandshakeAlt} fixedWidth />
                                    {sp.parentPartner.name}
                                </div>
                            </div>
                        </div>
                        <div className="entity-list__item-panel entity-list__item-panel--extra-spacing">
                            <div className="entity-list__item-value">
                                <p className="caption caption--right-aligned">{t("Gui.Manage.AssignedRole")}</p>
                                <p className="paragraph paragraph--small paragraph--bold paragraph--right-aligned">
                                    <FontAwesomeIcon className="paragraph__icon" icon={faUsers} fixedWidth />
                                    {t(`Entities.Role.${sp.roleOnChildPartner.name}`)}
                                </p>
                            </div>
                        </div>
                        <div className="entity-list__item-row">
                            <div className="entity-list__item-value">
                                <p className="paragraph paragraph--small">{sp.name}</p>
                            </div>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    ) : (
        <div>
            <p className="caption caption--italic">{t("Entities.Partner.NoSupportingPartners")}</p>
        </div>
    );
};
